<template>
	<div class="modContainer">
		<div :class="listData.lists.length>0?'listAndTitle':'listAndTitle operateZoneHover'">
			<div v-if="listData.lists.length==0" class="emptyDataContainer" style="text-align: center;" @click="uploadVideoFile()">
				<div class="addfilediv"></div>
				<p class="emptyDataTitle">点击或拖拽添加视频</p>
				<p class="emptyDataDesc">支持格式：mp4、mov、avi、flv 单个文件最大1G，单次支持上传50个</p>
				<p class="emptyDataDesc" style="margin-top:15px">添加更多内容：图文，音视频，文档请进入<span style='color:#1c4da8' @click.stop="togedit">高级编辑器</span></p>
				<p class="emptyDataDesc" style="margin-top:15px">更多视频功能：<span style='color:#1c4da8' @click.stop="tovideosys">视频刷一刷</span>、<span style='color:#1c4da8' @click.stop="tovideobfq">视频播放器</span></p>
				<input v-show="false" ref="fileRef" type="file" id="videoicker" accept="video/*" @change="videoAdd($event)" multiple>
				<span @click.stop="upgradeUrl" class="addFromLib upgradeUserLink">去除底部标识</span>
				<span @click.stop="addFromLib" class="addFromLib">从视频库导入</span>
			</div>
			<div v-else>
				
				<input @input="setTitle($event)" :value="title" type="text" placeholder="请输入标题 , 不输入则不显示"
					class="videoTitleBig">
				<div class="listContainer" @dragover="dragover($event)">
					<transition-group name="sort" tag="div">
						<div class="listInfo" v-for="(item,index) in listData.lists" :key="item.listIndex" draggable="true" @dragstart="dragstart(item)" @dragenter="dragenter(item,$event)" @dragend="dragend()" @dragover="dragover($event)">
							<div class="loadingCon"  v-if="item.upload_hanlde.progress!=101&&!item.exchanging.exchanging">
								<a-progress :strokeWidth="6" strokeColor="#09bd71" trailColor="white" :percent="item.upload_hanlde.progress" status="active" :show-info="false"/>
							</div>
							<div class="loadingCon" v-if="item.exchanging.exchanging">
								<a-progress :strokeWidth="6" strokeColor="#09bd71" trailColor="white" :percent="item.exchanging.progress" status="active" :show-info="false"/>
								<p class="changeTime">转码中，预计还需要{{item.exchanging.timeleft}}S</p>
							</div>
							<div class="listInfoL">
								<div class="coverContainer">
									<img v-if="item.cover_img==''" :src="$baseFunc.getQiniusign(item.transcode_url,0)">
									<img v-else :src="$baseFunc.getAliOssAuthKey(item.cover_img.url)" />
									<!-- <video :src="$baseFunc.getQiniusign(item.url,0)"></video> -->
									<!-- <img v-else src="" /> -->
								</div>
								<div class="namesContainer">
									<div>
										<input @click="editVideoName(index)" @input="setVideotitle($event,index)" placeholder="请输入标题" class="videoName1" :id="'videoNameId'+index"
											onfocus="this.select()"
											:value="item.filename" />
										<span @click="editVideoName(index)" style="margin-left: 8px;"
											class="mbm-iconfont mbm-pen iconEdit"></span>
									</div>
									<div>
										<input @click="editVideoSubName(index)" @input="setVideoSubtitle($event,index)" class="videoName2" placeholder="请输入描述" :id="'videoSubNameId'+index"
											onfocus="this.select()"
											:value="item.desc" />
										<span @click="editVideoSubName(index)" style="margin-left: 8px;"
											class="mbm-iconfont mbm-pen iconEdit"></span>
									</div>
								</div>
							</div>
							<div class="listInfoC">{{item.filesize}}</div>
							<div class="listInfoR">
								<span @click="delItem(index)">删除</span>
								<span @click="changeCover(index)">改封面</span>
								<span @click="changeVideo(index)">更换</span>
								<span @click="preView(index)">预览</span>
							</div>
						</div>
					</transition-group>
				</div>
				<input v-show="false" type="file" id="coverChangeId" accept="image/*" @change="coverChange($event)">
				<input v-show="false" type="file" id="videoChangeId" accept="video/*" @change="videoChange($event)">
				<input v-show="false" type="file" id="addVideoId" multiple accept="video/*" @change="videoAdd($event)">
				<a-button @click="addVideo" class="operateZoneAddvideo essential-color-main-btn">
					<template #icon>
						<PlusCircleOutlined />
					</template>
					添加视频
				</a-button>
				<span @click.stop="upgradeUrl" class="addFromLib upgradeUserLink">去除底部标识</span>
				<span @click.stop="addFromLib" class="addFromLib">从视频库导入</span>
			</div>
		</div>
		
		<div class="btnsContainer">
			<div v-if="generated">
				<a-button  @click="qreatNext()" class="btnsMargin" size="large">再建一个</a-button>
				<a-button v-if="dataChanged.dataChanged&&generated" :loading="generateQrcodeLoading" @click="toGenerate(2)" class="btnsMargin" size="large" type="primary">保存修改</a-button>
				<a-button  @click="toDownloadQrcode()" v-else class="btnsMargin" size="large" type="primary">下载二维码</a-button>
				<a-button  @click="previewbtn()" class="btnsMargin" size="large">预览</a-button>
				<div @click="downloadOrtherExtFunc()" class="download-orther-ext-jxuhs">下载其他格式</div>
			</div>
			<div v-else>
				<a-button :loading="generateQrcodeLoading" class="btnsMargin" size='large' type="primary" @click="toGenerate(1)">生成二维码</a-button>
			</div>
		</div>
		
		<!-- 预览文件model -->
		<a-modal :zIndex="2001" class="mbm_player_model" :title="use_file_type==1?'视频播放器':'音频播放器'"
			:visible="mbmPlayerModelShow"  @cancel="mbmPlayerModelClose" :footer="null" :destroyOnClose="true" :width="600">
			<player :pageType="use_file_type" :info="playinfo"></player>
		</a-modal>
		<caseView :casedata="casedata" @viewCaseClose="viewCaseClose" v-if="caseviewshow"></caseView>
	</div>
</template>

<script>
	import {PlusCircleOutlined} from '@ant-design/icons-vue';
	import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
	import { createVNode, defineComponent } from 'vue';
	import { Modal } from 'ant-design-vue';
	import { message } from 'ant-design-vue';
	import player from './player.vue';
	import caseView from './caseView.vue';
	
	import md5 from 'md5';
	import { Download } from '../assets/js/download.js';
	import config from "../config/config.js";
	import baseFunc from '../config/base_func.js';
	import { v4 as uuidv4 } from 'uuid';
	export default {
		name: 'videoMod',
		props: {
			listData:Object,
			dataChanged:Object,
			setData:Object,
			qrImg:String,
			img_prese: Number,
			img_style:Number
		},
		components: {
			PlusCircleOutlined,player,caseView
		},
		data() {
			return {
				casedata:{},
				caseviewshow:false,
				use_file_type:1,//当前播放文档类型
				mbmPlayerModelShow:false,//预览modal框
				listIndex:0,
				download : new Download(),
				delModalvisible:false,
				generated: false, //是否已生成二维码
				title:'',//标题
				titlecurrent:'',//临时标题
				generateQrcodeLoading:false,//生成二维码时加载状态
				addfileLoading:false,
				currentEdit: -1, //当前编辑视频的下标
				currentSubEdit: -1,//
				id_key:'',
				playinfo:{},//播放信息
				previewurl:'',//预览地址
				
			}			
		},
		watch:{
			
		},
		methods: {
			downloadOrtherExtFunc(){
				this.$parent.downloadOrtherExtFunc();
			},
			//再建一个
			qreatNext(){
				this.$parent.setCodetype(1);
			},
			clearidkey(){
				this.id_key='';
			},
			/*升级会员*/
			upgradeUrl(){
				window.open(config.upgradeUrl)
			},
			tovideosys(){
				window.open(config.url.videosys)
			},
			tovideobfq(){
				window.open(config.url.videobfq)
			},
			togedit(){
				window.open(config.url.geditDomian)
			},
			setgeneratedfalse(){
				this.generated=false;
			},
			viewCaseClose(){
				this.caseviewshow=false;
			},
			//二维码预览
			previewbtn(){
				// var data={
				// 	qrcode_img:this.qrImg,
				// 	qrcode_url:this.previewurl
				// }
				// this.casedata=data;
				// this.caseviewshow=true;
				this.$parent.openset();
			},
			//单文件预览
			preView(e){
				this.currentEdit=e;
				this.mbmPlayerModelShow=true;
				var data=this.listData.lists[this.currentEdit];
				data.party_path_g=data.transcode_url;
				this.playinfo=data;
			},
			mbmPlayerModelClose(){
				this.mbmPlayerModelShow=false;
			},
			addFromLib(){
				this.$parent.showfileMod()
			},
			// 下载二维码
			toDownloadQrcode(){
				this.download.downloadFile(this.qrImg);
			},
			// 生成二维码
			toGenerate(create_init){
				const self = this;
				var pagedata={
					name: "video",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					component_code: "video",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					sort: 0,
					content_html:{
						types: "video",/*类型 文件：file 图片：image 视频：video 音频：audio*/
						auto_increment: this.listData.lists.length,//(lists.length)
						img_prese: 1,/*图片展示设置 1：平铺 2：轮播 5：轮播切片*/
						img_style: 1,/*图片样式设置 1：留白 2：撑满 3：置顶撑满*/
						lists: this.listData.lists
					}
				}
				if(this.listData.lists.length==0){
					message.error('请先选择上传文件！');
					return;
				};
				this.generateQrcodeLoading=true;
				this.$apiRequest.post('/qrcode/create/createQrcodeIndex',{
					content:JSON.stringify(pagedata),
					mode:this.setData.openType,
					id_key:this.id_key,
					title:this.title
				}).then(res => {
					this.previewurl=res.data.data.h5_preview_url;//设置预览地址
					this.$parent.setIdkey(res.data.data.id_key);//idkey传给父组件
					this.id_key=res.data.data.id_key;
					// this.h5_preview_url=res.data.data.h5_preview_url;
					message.success(res.data.message);
					this.generated=true;
					this.$parent.changeContent({
						qrcode_type: "video",
						topCurrent: 1,
						create_init:create_init,/*1：当前新增 2：当前修改*/
						content: res.data.data.h5_preview_url,//xx.com
						id_key:this.id_key
					})
					if(typeof res.data.data.free_tips!="undefined" && res.data.data.free_tips){
						this.$baseFunc.checkState(res.data.data.free_tips).then(res => {}).catch(err=>{});
					}
					this.titlecurrent=this.title;
					this.dataChanged.dataChanged=false;
					this.generateQrcodeLoading=false;
				}).catch(err => {
					this.generateQrcodeLoading=false;
					this.$baseFunc.checkState(err.data).then(res => {
						if(res)self.toGenerate(create_init);
					}).catch(err => {});
				});
			},
			//设置标题
			setTitle(e){
				this.title=e.currentTarget.value;
				this.$emit('gettitle',e.currentTarget.value);
				if(this.title==this.titlecurrent){
					this.dataChanged.dataChanged=false;
				}else{
					this.dataChanged.dataChanged=true;
				}
			},
			//删除
			delItem(index){
				var that=this;
				Modal.confirm({
					title: () => '提示',
					icon: () => createVNode(ExclamationCircleOutlined),
					cancelText:'取消',
					centered:true,
					okText:'确认删除',
					okType: 'danger',
					content: () => '是否删除当前视频？',
					onOk() {
					  that.listData.lists.splice(index,1)
					},
					onCancel() {},
				});
				
			},
			videoAdd(event){
				// 先初始化
				// let currentData=this.listDataCurrent.lists;
				let files = event.target.files;
				let videoObj={
					listIndex:0,
					cover_img: "",
					duration: 0,
					extra_data_defult: {upload_type: '', current: 0},
					fileId: 0,
					file_code: 1,
					file_openid: "",
					file_status: 2,
					filename: "",
					filesize: "",
					filesize_byte: 0,
					height: 0,
					id: 0,
					key: "",
					low_transcode_url: "/",
					media_status: "",
					media_type: "",
					media_types_a: "",
					media_types_b: "",
					old_transcode_url: "",
					residue_available: 0,
					t_media_type: "",
					transcode_url: "",
					type: "",
					url: "",
					width: 0,
					_token: "",
					// 新增属性
					upload_hanlde:{
						progress:0,
					},
					desc:'',
					exchanging:{
						progress:0,
						exchanging:false,
						time:0,
						timeleft:0
					}
				};
				let all_total = files.length,have_upload = 0;
				for(let i=0;i<files.length;i++){
					this.addfileLoading=true;
					this.generateQrcodeLoading=true;
					this.listIndex=this.listData.lists.length;
					videoObj.listIndex=this.listIndex
					this.listData.lists.push(JSON.parse(JSON.stringify(videoObj)));
					// return
					let obj_i = this.listData.lists.length-1;
					this.$apiRequest.uploadMediaToQiniu(this,files[i],progress=>{
						/*进度条*/
						this.listData.lists[progress.extra_data_defult.current].upload_hanlde.progress=parseInt(progress.percent.toFixed(0));
					},complete=>{
						/*
							complete.code= 1：上传完成 201：正在转
							complete.total_media_transcode_time (预估转码总时间)
							complete.residue_media_transcode_time (预估剩余转码总时间)
						*/
						// console.log("完成：",this.listData.lists)
						if(complete.code==201){
							/*执行转码等待动画，关闭上传进度动画*/
							this.listData.lists[complete.extra_data_defult.current]['exchanging']={
								progress:(complete.total_media_transcode_time-complete.residue_media_transcode_time)/complete.total_media_transcode_time*100,
								exchanging:true,
								time:complete.total_media_transcode_time,
								timeleft:complete.residue_media_transcode_time
							}
							// console.log("剩余转码时间",complete,this.listData.lists)
						}
					},{
						"upload_type":"video",/*video：只能上传视频 ,audio：只能上传音频, media：音视频都可以上传（默认）*/
						"current":obj_i,
						"listIndex":this.listIndex,
					}).then(res => {
						have_upload++
						res['upload_hanlde']={
							progress:101
						};
						res['exchanging']={
							progress:101,
							exchanging:false,
							time:0
						};
						res.type='video';
						res.listIndex = res.extra_data_defult.listIndex
						this.listData.lists[res.extra_data_defult.current]=res;
						if(have_upload==all_total){
							this.addfileLoading=false;
							this.generateQrcodeLoading=false;
						}
					}).catch(err => {
						have_upload++
						if(have_upload==all_total){
							this.addfileLoading=false;
							this.generateQrcodeLoading=false;
						}
						this.listData.lists.length=this.listData.lists.length-1;
					});
				}
				
				/*清空input*/
				var obj = document.getElementById("addVideoId"); 
				if(obj){
					obj.value="";
				}
			},
			videoChange(event,index){
				let files = event.target.files;
				let currentData=JSON.parse(JSON.stringify(this.listData.lists[this.currentEdit]));
				this.listData.lists[this.currentEdit].upload_hanlde.progress=0;
				this.generateQrcodeLoading=true;
				this.addfileLoading=true;
				this.$apiRequest.uploadMediaToQiniu(this,files[0],progress=>{
					/*进度条*/
					this.listData.lists[progress.extra_data_defult.current].upload_hanlde.progress=parseInt(progress.percent.toFixed(0));
				},complete=>{
					if(complete.code==201){
						/*执行转码等待动画，关闭上传进度动画*/
						this.listData.lists[complete.extra_data_defult.current]['exchanging']={
							progress:(complete.total_media_transcode_time-complete.residue_media_transcode_time)/complete.total_media_transcode_time*100,exchanging:true,
							time:complete.total_media_transcode_time,
							timeleft:complete.residue_media_transcode_time
						}
						// console.log("剩余转码时间",complete,this.listData.lists)
					}
				},{
					"upload_type":"video",/*video：只能上传视频 audio：只能上传音频 media：音视频都可以上传（默认）*/
					"current":this.currentEdit,
				}).then(res => {
					res['upload_hanlde']={
						progress:101
					};
					res['exchanging']={
						progress:101,
						exchanging:false,
						time:0
					};
					res['listIndex']=this.listData.lists[this.currentEdit].listIndex;
					res.type='video';
					this.listData.lists[res.extra_data_defult.current]=res;
					this.generateQrcodeLoading=false;
					this.addfileLoading=false;
				}).catch(err => {
					this.listData.lists[err.extra_data_defult.current]=currentData;
					this.generateQrcodeLoading=false;
					this.addfileLoading=false;
				});
				
				var obj = document.getElementById("videoChangeId") ; 
				if(obj){
					obj.value="";
				}
			},
			//转码
			exchange(event){
				
			},
			//查转码进度
			exchangeStatus(event){
				
			},
			coverChange(event){
				let files = event.target.files;
				let currentData=JSON.parse(JSON.stringify(this.listData.lists[this.currentEdit]));
				this.listData.lists[this.currentEdit].upload_hanlde.progress=0;
				this.generateQrcodeLoading=true;
				this.addfileLoading=true;
				this.$apiRequest.uploadFileToAliOss(this,files[0],progress=>{
					/*进度条*/
					this.listData.lists[progress.extra_data_defult.current].upload_hanlde.progress=parseInt(progress.percent.toFixed(0));
				},complete=>{
					
				},{
					"upload_type":'img',
					"current":this.currentEdit
				}).then(res => {
					this.listData.lists[res.extra_data_defult.current].cover_img=res;
					this.listData.lists[res.extra_data_defult.current]['upload_hanlde']={
						progress:101
					};
					this.generateQrcodeLoading=false;
					this.addfileLoading=false;
				}).catch(err => {
					this.listData.lists[res.extra_data_defult.current]=currentData;
					this.generateQrcodeLoading=false;
					this.addfileLoading=false;
				});
				/*清空input*/
				var obj = document.getElementById("coverChangeId") ; 
				if(obj){
					obj.value="";
				}
			},
			//添加
			addVideo() {
				// this.currentEdit=-1;
				// this.listDataCurrent=JSON.parse(JSON.stringify(this.listData))
				document.getElementById('addVideoId').dispatchEvent(new MouseEvent('click'))
				
			},
			//h换封面
			changeCover(e) {
				document.getElementById('coverChangeId').dispatchEvent(new MouseEvent('click'))
				this.currentEdit = e;
			},
			//更换
			changeVideo(e) {
				this.currentEdit = e;
				document.getElementById('videoChangeId').dispatchEvent(new MouseEvent('click'))
			},

			//选择
			uploadVideoFile() {
				// this.listDataCurrent = JSON.parse(JSON.stringify(this.listData))
				this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
			},
			//*****************************************拖动排序
			dragstart(value) {
				this.oldData = value
			},
			// 记录移动过程中信息
			dragenter(value, e) {
				this.newData = value
				e.preventDefault()
			},
			// 拖拽最终操作
			dragend() {
				if (this.oldData !== this.newData) {
					let oldIndex = this.listData.lists.indexOf(this.oldData);
					let newIndex = this.listData.lists.indexOf(this.newData);
					let newItems = [...this.listData.lists];
					newItems.splice(oldIndex, 1);
					newItems.splice(newIndex, 0, this.oldData);
					this.listData.lists = [...newItems];
				}
			},
			// 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
			dragover(e) {
				e.preventDefault()
			},
			//*******************************************拖动排序
			setVideotitle(event,index){
				this.listData.lists[index].filename=event.currentTarget.value
			},
			setVideoSubtitle(event,index){
				this.listData.lists[index].desc=event.currentTarget.value
			},
			
			//修改视频名字editVideoSubName
			editVideoSubName(e) {
				this.currentSubEdit = e;
				this.currentEdit = -1;
				var id = 'videoSubNameId' + e;
				this.$nextTick(function() {
					document.getElementById(id).focus();
				})
			},
			editVideoName(e) {
				this.currentEdit = e;
				this.currentSubEdit = -1;
				var id = 'videoNameId' + e;
				this.$nextTick(function() {
					document.getElementById(id).focus();
				})
			},
		}
	}
</script>

<style scoped>
	.listInfoR>span:hover{
		color:#09bd71;
	}
	.changeTime{
		width:100%;
		text-align:center;
		position: absolute;
		left:0;
		bottom:4px;
		padding:0;
		margin:0;
		font-size: 12px;
		color:#09bd71;
	}
	.operateZoneAddvideo:hover,.operateZoneAddvideo:focus{
		color:#09bd71 !important;
		border-color:#09bd71 !important;
	}
	.mbm_move_model_center_footer .ant-btn-primary:hover, .ant-btn-primary:focus{
		background-color: #40a9ff;
		border-color: #40a9ff;
	}
	.namesContainer>div:hover span {
		display: block;
	}
	.loadingCon{
		width: 100%;
		height: 100%;
		position: absolute;
		left:0;
		bottom:0;
		background-color: #e0f9ee;
		z-index:20;
		display:flex;
		justify-content: center;
		border-radius:8px;
		align-items: center;
		flex-wrap: wrap;
		padding:0 100px;
	}
	.listContainer .ant-btn:hover{
		color: #09bd71;
		background: #fff;
		border-color: #09bd71;
	}
	.addFromLib{
	    position: absolute;
	    bottom: 10px;
	    right: 10px;
	    font-size: 12px;
	    cursor: pointer;
	    color: #585858;
	    padding: 5px;
		transition: all 0.3s;
	}
	.addFromLib:hover{
		color: #09bd71;
	}
	.upgradeUserLink{
		right: 100px;
	}
	.emptyDataDesc{
		font-size: 12px;
		    color: #999;
		    margin-top: 29px;
		    line-height: 12px;
	}
	.emptyDataTitle {
		font-size: 16px;
		line-height: 16px;
		color: #333;
		margin-top: 27px;
		transition: all 0.3s;
	}
	.emptyDataContainer:hover .emptyDataTitle{
		color: #09bd71;
	}
	.operateZoneHover:hover .addfilediv{
		background-image: url(/img/video2.png);
		transition: all .3s;
	}
	.addfilediv{
		width:50px;
		height:50px;
		background-image: url(/img/video2.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin:0 auto;
		transition: all .3s;
		
	}
	.operateZoneHover:hover{
			border-color:#09bd71;
	}
	.emptyDataContainer {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		height: 363px;
		cursor: pointer;
		padding-top: 100px;
	}

	.listInfoC {
		font-size: 12px;
		color: #585858;
	}
	.mbm-pen{
		font-size: 12px;
	}
	.iconEdit {
		cursor: pointer;
		display: none;
	}
	.operateZoneAddvideo {
		width: 584px;
		height: 51px;
		background-color: #f8f8f8;
		border: 1px solid #f8f8f8;
		border-radius: 8px;
		text-align: center;
		font-size: 14px;
		color: #585858;
		margin-top: 8px;
		margin-left: 8px;
		cursor: pointer;
		margin-bottom: 30px;
	}

	.listAndTitle {
		border: 1px dashed #e7e7e7;
		border-radius: 8px;
		position: relative;
		padding: 20px 25px;
		transition: all 0.3s;
		min-height: 363px;
	}

	.videoTitleBig::-webkit-input-placeholder {
		color: #999;
	}

	.videoTitleBig {
		width: 100%;
		border: 0;
		outline: none;
		background-color: white;
		text-align: center;
		font-size: 16px;
		/* height: 16px; */
		margin-bottom: 20px;
	}

	.sort-move {
		transition: transform .3s;
	}

	.btnsContainer {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
	.download-orther-ext-jxuhs{color: rgba(0,0,0,0.65);font-size: 14px;text-align: center;width: fit-content;cursor: pointer;transition: color 0.2s;position: absolute;left: 0;right: 0;margin: auto;top: 50px;}
	.download-orther-ext-jxuhs:hover{color:#09bd71;}

	.btnsMargin {
		margin: 0 8px;
		width: 155px;
	}

	.listInfoR>span {
		font-size: 12px;
		color: #585858;
		margin-right: 10px;
		cursor: pointer;
	}

	.namesContainer>div {
		width: 200px;
		margin-left: 9px;
		display: flex;
		    align-items: center;
	}

	.namesContainer input {
		max-width: 165px;
		font-size: 12px;
		background-color: #fff;
		border: 0;
		outline: none;
		text-overflow:ellipsis;
		font-size: 12px;
	}

	.listInfoL {
		display: flex;
		align-items: center;
	}

	.coverContainer img {
		max-width: 100%;
		max-height: 100%;
	}

	.coverContainer {
		width: 92px;
		height: 54px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #e0ded9;
	}

	.btnsContainer {
		height: 40px;
		margin-top: 52px;
		margin-bottom: 55px;
	}

	.listInfo:hover {
		border: 2px solid #09bd71;
	}

	.listContainer {
		/* min-height: 174px; */
	}

	.listInfo {
		width: 100%;
		height: 69px;
		border: 2px solid #fff;
		border-radius: 8px;
		padding-left: 5px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: space-between;
		transition: all .3s;
		cursor: pointer;
		/* margin-bottom: 20px; */
		position:relative;
	}

	.modContainer {
		width: 100%;
		padding: 30px 30px 0;
	}
</style>
